import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "../Styles/Legal.css";

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <Navbar />

      <section className="page-hero">
        <div className="page-hero-particles">
          <span className="ph-particle ph-particle-1"></span>
          <span className="ph-particle ph-particle-2"></span>
          <span className="ph-particle ph-particle-3"></span>
        </div>
        <div className="container">
          <span className="section-tag">Legal</span>
          <h1 className="page-hero-title">Privacy Policy</h1>
          <p className="page-hero-subtitle">How we collect, use, and protect your personal information.</p>
        </div>
      </section>

      <section className="legal-content section-padding">
        <div className="container">
          <div className="legal-body">
            <p className="legal-updated">Last updated: October 21, 2026</p>

            <h2>Introduction</h2>
            <p>
              Ebenezer Family Group LLC, doing business as Ebenwealth ("Ebenwealth," "we," "our," or "us"), values your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you visit ebenwealth.com, contact us, or use our services, including our text messaging program.
            </p>

            <h2>Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
              <li><strong>Personal information:</strong> your name, email address, phone number, date of birth (for example, for birthday greetings), and other details you give us when you contact us, book an appointment, or sign up for our services.</li>
              <li><strong>Financial information:</strong> limited details needed for insurance, retirement, or savings programs, handled securely and only with your consent.</li>
              <li><strong>Technical information:</strong> IP address, browser type, device information, and usage data collected automatically through cookies or analytics tools.</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <p>We may use your information to:</p>
            <ul>
              <li>Provide and improve our financial education and client solutions.</li>
              <li>Respond to your questions and offer personalized recommendations.</li>
              <li>Schedule appointments and send appointment reminders.</li>
              <li>Send reminders about policy renewals and reviews.</li>
              <li>Process applications for agent opportunities.</li>
              <li>Send updates, newsletters, or promotional emails (you can unsubscribe at any time using the link in each email).</li>
              <li>Send text messages you have agreed to receive (see "Text Messaging (SMS)" below).</li>
              <li>Meet legal and regulatory requirements.</li>
            </ul>

            <h2>Text Messaging (SMS)</h2>
            <p>
              If you give us your mobile number and agree to receive text messages, we will use it only to send the types of messages you chose, such as appointment reminders, policy renewal and review reminders, birthday greetings, and, if you opt in to marketing texts, special offers, discounts, and service updates. Agreeing to receive texts is optional and is not required to use our website or buy any product or service.
            </p>
            <p>
              You can opt out at any time by replying STOP to any text message. You can reply HELP for assistance. Message and data rates may apply. Message frequency may vary.
            </p>

            <h2>Sharing of Information</h2>
            <p>
              We may share information only with service providers who help us deliver our services, when required by law, regulation, or legal process, and to protect the rights, property, or safety of Ebenwealth, our clients, or the public.
            </p>
            <p>
              No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. Information sharing to subcontractors in support services, such as customer service, is permitted. All other use case categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
            </p>

            <h2>Data Security</h2>
            <p>
              We use reasonable technical and organizational measures to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet is 100% secure.
            </p>

            <h2>Cookies and Tracking</h2>
            <p>
              Our website may use cookies and similar technologies to improve your experience, analyze traffic, and personalize content. You can manage cookie preferences through your browser settings.
            </p>

            <h2>International Users</h2>
            <p>
              Because we serve clients in the United States and abroad, your information may be transferred to and processed outside your country of residence. By using our services, you consent to these transfers.
            </p>

            <h2>Your Rights</h2>
            <p>Depending on where you live, you may have the right to:</p>
            <ul>
              <li>Access, correct, or delete your personal information.</li>
              <li>Restrict or object to certain uses of your information.</li>
              <li>Withdraw your consent to marketing communications, including text messages (reply STOP) and emails (use the unsubscribe link).</li>
            </ul>
            <p>To make a request, contact us using the details below.</p>

            <h2>Third-Party Links</h2>
            <p>
              Our website may contain links to other websites. We are not responsible for the privacy practices or content of those sites.
            </p>

            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Changes will be posted on this page with a new "Last updated" date.
            </p>

            <h2>Contact Us</h2>
            <div className="legal-contact-box">
              <p><strong>Ebenezer Family Group LLC, doing business as Ebenwealth</strong></p>
              <p>6160 Summit Dr N,<br/>Suite #145,<br/>Brooklyn Center, MN 55429</p>
              <p>Phone: <a href="tel:+17632719700">+1 763-271-9700</a></p>
              <p>Email: <a href="mailto:financialsolutions@ebenwealth.com">financialsolutions@ebenwealth.com</a></p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
